// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__PHo8y","notes":"Notes_notes__37ATf"};